import axios from "axios";

const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;

export const getTopics = (webmasterTitle, params) => (dispatch) => {
  axios
    .get(`${API}${VERSION}/${webmasterTitle}/topics`, {
      params,
    })
    .then((response) => {
      dispatch({
        type: "GET_TOPICS",
        data: response.data.data.topicsList,
        params,
      });
    });
};

export const getLastTopics = (webmasterTitle, params) => (dispatch) => {
  axios
    .get(`${API}${VERSION}/${webmasterTitle}/last/topics`, {
      params,
    })
    .then((response) => {
      dispatch({
        type: "GET_LAST_TOPICS",
        LastTopics: response.data.data,
        params,
      });
    });
};
